import {Component, Input, ViewChild} from '@angular/core';
import { Popover } from 'primeng/popover';

@Component({
    selector: 'app-packages-table-card',
    templateUrl: './packages-table-card.component.html',
    styleUrls: ['./packages-table-card.component.scss'],
    standalone: false
})
export class PackagesTableCardComponent {

  @Input() packagesTableData:any;
  @ViewChild('op') popover!: Popover;

  showPopover(event: Event) {
    this.popover.toggle(event);
  }
}

